import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

/* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */
import React, { Component } from 'react';
import { isSameDay } from './DateUtils';
import { hasOwnProp } from './Helpers';
import defaultClassNames from './classNames';

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }

  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = /*#__PURE__*/function () {
  var Day = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Day, _Component);

    function Day() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = Day.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      var _this = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);

      if (propNames.length !== nextPropNames.length) {
        return true;
      }

      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);

          if (modifiers.length !== nextModifiers.length) {
            return true;
          }

          return modifiers.some(function (mod) {
            return !hasOwnProp(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }

        if (name === 'day') {
          return !isSameDay(_this.props[name], nextProps[name]);
        }

        return !hasOwnProp(nextProps, name) || _this.props[name] !== nextProps[name];
      });
    };

    _proto.render = function render() {
      var _this$props = this.props,
          classNames = _this$props.classNames,
          modifiersStyles = _this$props.modifiersStyles,
          day = _this$props.day,
          tabIndex = _this$props.tabIndex,
          empty = _this$props.empty,
          modifiers = _this$props.modifiers,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          onMouseUp = _this$props.onMouseUp,
          onMouseDown = _this$props.onMouseDown,
          onClick = _this$props.onClick,
          onKeyDown = _this$props.onKeyDown,
          onTouchStart = _this$props.onTouchStart,
          onTouchEnd = _this$props.onTouchEnd,
          onFocus = _this$props.onFocus,
          ariaLabel = _this$props.ariaLabel,
          ariaDisabled = _this$props.ariaDisabled,
          ariaSelected = _this$props.ariaSelected,
          children = _this$props.children;
      var className = classNames.day;

      if (classNames !== defaultClassNames) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += " " + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return " " + className + "--" + modifier;
        }).join('');
      }

      var style;

      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return /*#__PURE__*/React.createElement("div", {
          "aria-disabled": true,
          className: className,
          style: style
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: className,
        tabIndex: tabIndex,
        style: style,
        role: "gridcell",
        "aria-label": ariaLabel,
        "aria-disabled": ariaDisabled,
        "aria-selected": ariaSelected,
        onClick: handleEvent(onClick, day, modifiers),
        onKeyDown: handleEvent(onKeyDown, day, modifiers),
        onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
        onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
        onMouseUp: handleEvent(onMouseUp, day, modifiers),
        onMouseDown: handleEvent(onMouseDown, day, modifiers),
        onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
        onTouchStart: handleEvent(onTouchStart, day, modifiers),
        onFocus: handleEvent(onFocus, day, modifiers)
      }, children);
    };

    return Day;
  }(Component);

  Day.defaultProps = {
    tabIndex: -1
  };
  Day.defaultProps = {
    modifiers: {},
    modifiersStyles: {},
    empty: false
  };
  return Day;
}();

export default Day;